import { createContext, type Dispatch, type ReactNode, type SetStateAction, useContext, useMemo } from "react";

export interface AppNavContextValue {
  side: "left" | "right";
  isCollapsed: boolean;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
}

export const AppNavContext = createContext<AppNavContextValue | null>(null);

export interface AppNavProviderProps {
  side?: "left" | "right";
  isCollapsed: boolean;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
}

export const AppNavProvider = ({ children, side = "left", isCollapsed, setIsCollapsed }: AppNavProviderProps) => {
  const value: AppNavContextValue = useMemo(
    () => ({
      side,
      isCollapsed,
      setIsCollapsed,
    }),
    [side, isCollapsed, setIsCollapsed]
  );

  return <AppNavContext.Provider value={value}>{children}</AppNavContext.Provider>;
};

export const useAppNav = () => {
  const context = useContext(AppNavContext);

  if (!context) {
    throw new Error("useAppNav must be used within an AppNavProvider");
  }

  return context;
};
